import test = require('blue-tape')
import { join } from 'path'
import { bundle } from './bundle'
import { rimraf, readFile } from './utils/fs'
import { EventEmitter } from 'events'

const emitter = new EventEmitter()

test('bundle', t => {
  t.test('bundle everything', t => {
    const FIXTURE_DIR = join(__dirname, '__test__/bundle')

    return rimraf(join(FIXTURE_DIR, 'out'))
      .then(() => {
        return bundle({
          cwd: FIXTURE_DIR,
          name: 'example',
          out: join(FIXTURE_DIR, 'out', 'bundle.d.ts'),
          global: false,
          emitter
        })
      })
      .then(function () {
        return readFile(join(FIXTURE_DIR, 'out', 'bundle.d.ts'), 'utf8')
      })
      .then(function (contents) {
        t.equal(contents, [
          `// Generated by typings`,
          `// Source: custom_typings/test.d.ts`,
          `declare module \'~example~test/test\' {`,
          `export function test (): string;`,
          `}`,
          ``,
          `// Generated by typings`,
          `// Source: index.d.ts`,
          `declare module \'example\' {`,
          `export { test } from \'~example~test/test\'`,
          `}`,
          ''
        ].join('\n'))
      })
  })
})
